import { enqueueSnackbar } from "notistack";

export function notifyContactEnrollment(result) {
  const failed = result.ineligible + result.missing;
  const summary = `Enrolled ${result.enrolled}; already enrolled ${result.alreadyEnrolled}; ineligible ${result.ineligible}; missing ${result.missing}.`;
  const reasons = [
    ...new Set(
      result.results
        .filter(
          (item) => !["enrolled", "already_enrolled"].includes(item.outcome),
        )
        .map((item) => item.message),
    ),
  ];
  enqueueSnackbar([summary, ...reasons].join(" "), {
    variant: failed ? (result.enrolled ? "warning" : "error") : "success",
    autoHideDuration: failed ? 10000 : 6000,
  });
}
